import * as api from '~/api';
import { ROOM, SCHEDULE } from '~/utils/urlApi';

export const apiRequestRoomList = (
  baseUrl,
  info,
  hospitalId = 2,
  subjectId,
  selectedDate,
  // selectedDayOfWeek,
) => {
  var config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const formData = new FormData();
  formData.append('user_id', info.user_id);
  formData.append('access_token', info.access_token);
  formData.append('hospital_id', hospitalId);
  formData.append('subject_id', subjectId);
  formData.append('date', selectedDate.format('YYYY-MM-DD')); // 2019-08-23
  formData.append('dayofweek', selectedDate.day()); // 5

  return api.postHttpRequestAsync(
    `${baseUrl}${ROOM.ROOM_LIST_API_REQUEST}`,
    formData,
    config,
  );
};

export const apiRequestRoomDetail = (
  baseUrl,
  info,
  hospitalId,
  subjectId,
  selectedDate,
  // selectedDayOfWeek,
  roomId,
  doctorId,
) => {
  var config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  };

  const formData = new FormData();
  formData.append('user_id', info.user_id);
  formData.append('access_token', info.access_token);
  formData.append('hospital_id', hospitalId);
  formData.append('subject_id', subjectId);
  formData.append('date', selectedDate.format('YYYY-MM-DD')); // 2019-08-23
  formData.append('dayofweek', selectedDate.day()); // 5
  formData.append('room_id', roomId);
  formData.append('doctor_id', doctorId);

  let hospitalApi = '';
  switch (hospitalId) {
    case 2:
      hospitalApi = ROOM.SELECTED_ROOM_AND_DOCTOR_API_REQUEST;
      break;
    case 5:
      hospitalApi = SCHEDULE.GET_BY_DOCTOR;
      break;
    default:
      break;
  }

  return api.postHttpRequestAsync(`${baseUrl}${hospitalApi}`, formData, config);
};

export const apiDoctorTimeSlot = (
  baseUrl,
  info,
  hospitalId = 2,
  subjectId,
  selectedDate,
  selectedDayOfWeek,
  roomId,
  doctorId,
) => {
  let params = '';
  params += `?user_id=${info.user_id}`;
  params += `&access_token=${info.access_token}`;
  params += `&hospital_id=${hospitalId}`;
  params += `&date=${selectedDate.format('YYYY-MM-DD')}`;
  params += `&dayofweek=${selectedDayOfWeek}`;
  params += `&subject_id=${subjectId}`;
  params += `&room_id=${roomId}`;
  params += `&doctor_id=${doctorId}`;

  let hospitalApi = ROOM.SELECTED_ROOM_AND_DOCTOR_API_REQUEST;
  if (hospitalId === 5) {
    hospitalApi = SCHEDULE.GET_BY_DOCTOR;
  }

  return api.postHttpRequestAsync(`${baseUrl}${hospitalApi}${params}`);
};
